import { Text } from '@vkontakte/vkui';
import React, { FC } from 'react';
import { Button, ButtonSizeMode, ButtonVariant } from 'reactApp/ui/Button/Button';
import { useBuyCleanerTariff } from 'reactApp/ui/QuotaCleanerPage/hooks/useBuyCleanerTariff';

import styles from './QuotaCleanerSpacePromo.css';

const messages = {
    mainText: 'Увеличьте место, чтобы не удалять файлы.',
};

export const QuotaCleanerSpacePromo: FC = () => {
    const { tariffPrice, onBuy } = useBuyCleanerTariff();
    if (!tariffPrice) {
        return null;
    }

    return (
        <div className={styles.wrapper} data-qa-id="quota-cleaner-space-promo">
            <Text Component="h6" weight="2">
                {messages.mainText}
            </Text>
            <div className={styles.button}>
                <Button theme="octavius" sizeMode={ButtonSizeMode.extraSmall} variant={ButtonVariant.contrast} onClick={onBuy}>
                    <Text Component="h6" weight="2">{`Купить за ${tariffPrice} ₽ в месяц`}</Text>
                </Button>
            </div>
        </div>
    );
};
